import { default as BaseMaskedInput } from 'react-text-mask';
import type { Mask } from 'react-text-mask';

import Input from 'components/partials/input/input';

import * as masks from 'constants/forms-validaition';

interface MaskedInputProps {
  value?: string;
  mask: string;
  showMask?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  [key: string]: unknown;
}

type MaskRender = (
  ref: (input: HTMLInputElement | null) => void,
  inputProps: {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
    value?: string;
    [key: string]: unknown;
  }
) => React.JSX.Element;

const MaskedInput = ({
  value,
  mask,
  showMask = true,
  ...props
}: MaskedInputProps) => (
  <BaseMaskedInput
    mask={(masks as Record<string, Mask>)[mask]}
    showMask={showMask}
    guide={showMask}
    render={
      ((ref, inputProps) => (
        <Input
          data-testid="masked-input"
          ref={ref}
          {...props}
          {...inputProps}
          defaultValue={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            inputProps.onChange(e);
            props.onChange(e);
          }}
          onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
            inputProps.onBlur(e);
            props.onBlur(e);
          }}
        />
      )) as MaskRender
    }
  />
);

export default MaskedInput;
